import React, {useRef, useState, useEffect} from 'react';
import ProductCard from '../components/ProductCard';
import ProductBanner from '../components/ProductBanner';
import Navbar from '../components/Navbar';
import {database} from '../config/firebaseConfig';
import { Toaster } from 'react-hot-toast';
import AlertOnLoading from '../components/AlertOnLoading';
import { Parallax, Pagination, Navigation, Autoplay} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import Footer from '../components/Footer';
import SearchBar from '../components/SearchBar';
import {XMarkIcon} from '@heroicons/react/24/outline';
import { collection, getDocs, setDoc, doc} from "firebase/firestore";
import AlertBox from '../components/AlertBox';

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../styles/customSwiper.css";

function ServicesPage() {
  const SUCCESS = "success";
  const WARNING = "warning";

  const WAIT_TIME = 1000; //Waits for 0.5s
  const notInitialRender = useRef(false);

  const [currentPagePackage, setCurrentPagePackage] = useState(1);
  let packagesPerPages;

  const [currentPageTest, setCurrentPageTest] = useState(1);
  let testsPerPages;
  
  const [newData, setNewData] = useState(true); //it functions to validate if it needs to re-render

  let maxBannerProducts;

  const [isOpenInquiry, setIsOpenInquiry] = useState(false);

  const [uploading, setUploading] = useState(false);

  const [showingPackages, setShowingPackages] = useState(false);
  const [showingTests, setShowingTests] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [resultsQuery, setResultsQuery] = useState(null);

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const getMaxProducts = (width) => {
    if (width >= 1778) {
      if (showingPackages) {
        packagesPerPages = 10;
      } else {
        packagesPerPages = 5;
      }

      if (showingTests) {
        testsPerPages = 10;
      } else {
        testsPerPages = 5;
      }
      maxBannerProducts = 5;
      return 5;
    }

    if (width >= 1024) {
      if (showingPackages) {
        packagesPerPages = 8;
      } else {
        packagesPerPages = 4;
      }

      if (showingTests) {
        testsPerPages = 8;
      } else {
        testsPerPages = 4;
      }
      maxBannerProducts = 4;
      return 4;
    }

    if (width >= 768) {
      if (showingPackages) {
        packagesPerPages = 6;
      } else {
        packagesPerPages = 3;
      }

      if (showingTests) {
        testsPerPages = 6;
      } else {
        testsPerPages = 3;
      }
      maxBannerProducts = 3;
      return 3;
    }

    if (width>= 640) {
      if (showingPackages) {
        packagesPerPages = 6;
      } else {
        packagesPerPages = 4;
      }
      if (showingTests) {
        testsPerPages = 6;
      } else {
        testsPerPages = 4;
      }
      maxBannerProducts = 3;
      return 4;
    }

    if (showingPackages) {
      packagesPerPages = 5;
    } else {
      packagesPerPages = 3;
    }
    if (showingTests) {
      testsPerPages = 5;
    } else {
      testsPerPages = 3;
    }
    maxBannerProducts = 3;
    return 3;
  }

  const [_, setMaxVisiblePackages] = useState(getMaxProducts(window.innerWidth));
  const [packages, setPackages] = useState(null);
  const [tests, setTests] = useState(null);

  const lastPackageIndex = currentPagePackage * packagesPerPages;
  const firstPackageIndex = lastPackageIndex - packagesPerPages;

  const lastTestIndex = currentPageTest * testsPerPages;
  const firstTestIndex = lastTestIndex - testsPerPages;

  const loadMoreProductsPackage = () => {
    setShowingPackages(true);
    setMaxVisiblePackages(packagesPerPages);
  }

  const loadMoreProductsTest = () => {
    setShowingTests(true);
    setMaxVisiblePackages(testsPerPages);
  }

  const hideProductsTest = () => {
    setCurrentPageTest(1);
    setShowingTests(false);
    setMaxVisiblePackages(getMaxProducts(window.innerWidth));
  }

  const hideProductsPackage = () => {
    setCurrentPagePackage(1);
    setShowingPackages(false);
    setMaxVisiblePackages(getMaxProducts(window.innerWidth));
  }
  
  const resizeProducts = () => {
    hideProductsPackage();
    hideProductsTest();
    return;
  }
  
  const formatPrice = (value) => {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }

  const keys = ["nombre", "descripcion"];

  const search = () => {
    const packagesFiltered = packages?.filter((packet) =>
      keys.some((key) => packet[key].toLowerCase().includes(searchQuery.trim().toLowerCase())) 
    ).map((packet) => (
      {...packet}
    ))
    
    const testsFiltered = tests?.filter((test) =>
      keys.some((key) => test[key].toLowerCase().includes(searchQuery.trim().toLowerCase())) 
    ).map((test) => (
      {...test}
    ))

    setResultsQuery([].concat(packagesFiltered, testsFiltered));
  }

  const closeSearch = () => {
    setSearchQuery("");
    setResultsQuery(null);
  }

  /*
    Creates a new inquiry document on firebase
  */
    async function createInquiry() {
      const newsCollectionRef = collection(database, "inquiries");
      if (fullName === "") {
          AlertBox(WARNING, '¡Debe ingresar su nombre completo!');
          return;

      } else if (email === "") {
          AlertBox(WARNING, '¡Debe ingresar un correo electrónico!');
          return;

      } else if (phone === "") {
          AlertBox(WARNING, '¡Debe ingresar un número de teléfono!');
          return;
      } else if (message === "") {
        AlertBox(WARNING, '¡Debe ingresar un mensaje para la consulta!');
        return;
      } else {
          const addButton = document.querySelectorAll("#addRegister");
          console.log(addButton);
          addButton[0].setAttribute("disabled", true);

          setUploading(true);

          const newNewsRef = doc(newsCollectionRef);
          await setDoc(newNewsRef, {name: fullName, email:email, phone:phone, message:message});

          setFullName("");
          setEmail("");
          setMessage("");
          setPhone("");

          addButton[0].removeAttribute("disabled");

          setUploading(false);
          
          AlertBox(SUCCESS, 'Consulta realizada exitosamente');
          return;
      }
  }
  
  /*
      Gets packages and tests
  */
  useEffect(() => {
    if (notInitialRender.current && newData){
        AlertOnLoading(WAIT_TIME+100);
    }else {
        notInitialRender.current = true;
    } 
    const interval = setInterval(() => { //Autorize re-render
        if (newData) {
            const PackagesRef = collection(database, "paquetes");
            const TestsRef = collection(database, "pruebas");
            const getPackages = async() => {
              const data = await getDocs(PackagesRef);
              setPackages(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
            }

            const getTests = async() => {
              const data = await getDocs(TestsRef);
              setTests(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
            }

            console.log("Actualizo");
            getPackages();
            getTests();
            setNewData(!newData);
        }
    }, WAIT_TIME);
    return () => clearInterval(interval);
  }, [packages, newData])

  window.addEventListener("resize", resizeProducts)
  return (
    <div>
      <div>
        <Toaster
        toastOptions={{
        duration:3000,
        }}/>
      </div>

      <Navbar activePage={"/Services"} />
      <div className='w-full h-navbar-mobile sm:h-navbar'></div>
      
        <Swiper
          style={{
            "--swiper-navigation-color": "#000",
            "--swiper-pagination-color": "#3B8EED",
          }}
          speed={600}
          parallax={true}
          pagination={{
            clickable: true,
            type:"bullets"
          }}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          navigation={true}
          modules={[Autoplay, Parallax, Pagination, Navigation]}
          className="mySwiper h-card-web bg-white "
        >
          <div className='hidden parallax-bg w-5 h-5 lg:flex'>
            <img src='/images/BannerProducts.svg' className='absolute w-1/12 max-w-banner-size top-1/3 left-0' alt=''></img>
            <img src='/images/BannerProducts.svg' className='absolute w-1/12 max-w-banner-size bottom-0 right-0' alt=''></img>
          </div>

          {
            packages? packages.slice(0, maxBannerProducts).map((packet) => (
              <SwiperSlide key={packet.id}>
                <ProductBanner
                  id={packet.id} 
                  title={packet.nombre}
                  description={packet.descripcion}
                  price={formatPrice(packet.precio)}
                  image={packet.imagen}
                />
              </SwiperSlide>
            )) 
            
            : 
            
              <SwiperSlide key={0}>
                <ProductBanner
                  id={0} 
                  title={"Cargando..."}
                  description={"Cargando..."}
                  price={formatPrice("0")}
                  image={"https://flowbite.com/docs/images/carousel/carousel-2.svg"}
                />
              </SwiperSlide>
          }
        </Swiper>
      
      <div className='relative w-full h-96 bg-white mt-6'>
        <div className='absolute px-4 flex flex-col w-full h-auto sm:px-8 mt-6'>
          <h2 className='text-lg lg:text-xl'>Buscador </h2>
          <span className='lg:w-80 w-60 border border-primary-100 mb-5'></span>
        </div>
        <img src='/images/blob1.svg' alt='' className='absolute w-[12%] form1:w-[7%] h-full left-0 top-20 bottom-0 my-auto hidden lg:block'></img>
        <img src='/images/blob2.svg' alt='' className='absolute w-[12%] form1:w-[8%] h-full right-0 -top-20 bottom-0 my-auto hidden lg:block'></img>
        <SearchBar value={searchQuery} storage={setSearchQuery} className="absolute top-0" function={search} options={["ola", "olo"]} />
      </div>

      <div className={`${resultsQuery? "relative h-auto w-full bg-white mt-6": "hidden"}`}>
        <button onClick={closeSearch} className='absolute top-5 right-4 hover:text-primary-100 hover:scale-110'><XMarkIcon className='w-8 h-8 lg:w-10 lg:h-10'/></button>

        <div className='px-4 flex flex-col w-full h-auto sm:px-8 mt-6 pt-6'>
          <h2 className='text-lg lg:text-xl'>Resultados </h2>
          <span className='lg:w-80 w-60 border border-primary-100 mb-5'></span>
        </div>

        <div className={`px-4 w-full h-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 form1:grid-cols-5 gap-8 justify-items-center py-6 sm:py-4`}>
          {
            resultsQuery?.map((result) => (
              <div key={result.id}>
                <ProductCard
                  id={result.id} 
                  image={result.imagen} 
                  title={result.nombre} 
                  description={result.descripcion}
                  price={formatPrice(result.precio)}  />
              </div>            
            ))
          }
        </div>
      </div>
        
      <div className='flex justify-center items-center bg-inquiries w-full h-footer-height mt-6 bg-no-repeat bg-auto lg:bg-cover bg-white'>
          <div className='w-4/5 h-60 bg-primary-300 rounded-xl max-w-2xl flex flex-col items-center justify-center space-y-1'>
            <img src='/images/question-mark.svg' alt="" className='w-14 h-14 lg:w-20 lg:h-20'></img>
            <div className='font-bold text-lg lg:text-xl'>
              ¿Buscas algo en específico? 
            </div>
            <div className='text-base px-4 text-center lg:text-lg'>
              Nosotros te ayudamos a encontrarlo rápidamente
            </div>
            
            <div className='w-full pt-4 flex justify-center'>
              <button onClick={() => {setIsOpenInquiry(!isOpenInquiry)}}
                className='w-3/5 py-2 text-white font-semibold bg-primary-100 rounded-md text-lg hover:bg-primary-200 cursor-pointer ease-in-out'>
                Realice su consulta
              </button>
            </div>
          </div>
      </div>

      <div className='relative w-full h-auto bg-white'>
        <div onClick={!showingPackages? loadMoreProductsPackage:hideProductsPackage} className={`w-28 absolute left-0 right-0 mx-auto px-3 py-2 border border-primary-100 rounded-md lg:hidden
                        text-center text-primary-100 cursor-pointer hover:bg-primary-100 hover:text-white ease-in-out ${showingPackages? "mb-20 bottom-4 sm:-bottom-2": "mb-16 -bottom-8 sm:-bottom-10"}`}>
          {!showingPackages? "Ver más":"Ocultar"}
        </div>

        <div onClick={!showingPackages? loadMoreProductsPackage:hideProductsPackage} className='w-28 hidden absolute top-6 right-6 px-3 py-2 border border-primary-100 rounded-md lg:block
                        text-center text-primary-100 cursor-pointer hover:bg-primary-100 hover:text-white ease-in-out'>
          {!showingPackages? "Ver más":"Ocultar"}
        </div>

        <div className='px-4 py-6 flex flex-col w-full h-auto lg:py-8 sm:px-8 mt-6'>
          <h2 className='text-lg lg:text-xl'>Paquetes </h2>
          <span className='lg:w-80 w-60 border border-primary-100 mb-5'></span>
        </div>

        <div className={`${packages? "px-4 w-full h-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 form1:grid-cols-5 gap-8 justify-items-center pb-6 sm:pb-4" : "flex w-full"} `}>
          {
            packages? packages.slice(firstPackageIndex, lastPackageIndex).map((packet) => (
              <div key={packet.id}>
                <ProductCard
                  id={packet.id} 
                  image={packet.imagen} 
                  title={packet.nombre} 
                  description={packet.descripcion}
                  price={formatPrice(packet.precio)}
                  action={setIsOpenInquiry}  />
              </div>
            ))
            
            :

            <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                    <path clipRule='evenodd'
                        d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                        fill='currentColor' fillRule='evenodd' />
                </svg>
                <div>
                    Cargando...
                </div>
            </div>
          }
        </div>

        <div className={`${showingPackages? "h-4 sm:h-16 w-full" : "h-20 w-full"} lg:hidden`}>

        </div>

        <div className={`${showingPackages? "flex": "hidden"} w-full items-center justify-evenly pb-5 flex-col sm:flex-row`}>
          <span className={`text-sm text-gray-700 mt-10 sm:mt-0`}>
              Mostrando <span className="font-semibold text-gray-900">{lastPackageIndex >= packages?.length? packages?.length:lastPackageIndex}</span> de <span className="font-semibold text-gray-900">{packages?.length}</span> resultados
          </span>
          <div className="inline-flex mt-2 xs:mt-0">
              <button
                  onClick={() => {setCurrentPagePackage(currentPagePackage - 1)}} 
                  className={`${currentPagePackage === 1? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium rounded-l`}>
                  Anterior
              </button>
              <button 
                  onClick={() => {setCurrentPagePackage(currentPagePackage + 1)}}
                  
                  className={`${lastPackageIndex >= packages?.length? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium border-0 border-l border-white rounded-r`}>
                  Siguiente
              </button>
          </div>
        </div>
      </div>

      <div className='relative w-full h-auto bg-white'>
        <div onClick={!showingTests? loadMoreProductsTest:hideProductsTest} className={`w-28 absolute left-0 right-0 mx-auto px-3 py-2 border border-primary-100 rounded-md lg:hidden
                        text-center text-primary-100 cursor-pointer hover:bg-primary-100 hover:text-white ease-in-out ${showingTests? "mb-20 bottom-4 sm:-bottom-2": "mb-16 -bottom-8 sm:-bottom-10"}`}>
          {!showingTests? "Ver más":"Ocultar"}
        </div>

        <div onClick={!showingTests? loadMoreProductsTest:hideProductsTest} className='w-28 hidden absolute top-6 right-6 px-3 py-2 border border-primary-100 rounded-md lg:block
                        text-center text-primary-100 cursor-pointer hover:bg-primary-100 hover:text-white ease-in-out'>
          {!showingTests? "Ver más":"Ocultar"}
        </div>

        <div className='px-4 py-6 flex flex-col w-full h-auto lg:py-8 sm:px-8 mt-6'>
          <h2 className='text-lg lg:text-xl'>Pruebas </h2>
          <span className='lg:w-80 w-60 border border-primary-100 mb-5'></span>
        </div>

        <div className={`${tests? "px-4 w-full h-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 form1:grid-cols-5 gap-8 justify-items-center pb-6 sm:pb-4" : "flex w-full"} `}>
          {
            tests? tests.slice(firstTestIndex, lastTestIndex).map((test) => (
              <div key={test.id}>
                <ProductCard
                  id={test.id} 
                  image={test.imagen} 
                  title={test.nombre} 
                  description={test.descripcion}
                  price={formatPrice(test.precio)}
                  action={setIsOpenInquiry}  />
              </div>
            ))
            
            :

            <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                    <path clipRule='evenodd'
                        d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                        fill='currentColor' fillRule='evenodd' />
                </svg>
                <div>
                    Cargando...
                </div>
            </div>
          }
        </div>

        <div className={`${showingTests? "h-4 sm:h-16 w-full" : "h-20 w-full"} lg:hidden`}>

        </div>

        <div className={`${showingTests? "flex": "hidden"} w-full items-center justify-evenly pb-5 flex-col sm:flex-row`}>
          <span className={`text-sm text-gray-700 mt-10 sm:mt-0`}>
              Mostrando <span className="font-semibold text-gray-900">{lastTestIndex >= tests?.length? tests?.length:lastTestIndex}</span> de <span className="font-semibold text-gray-900">{tests?.length}</span> resultados
          </span>
          <div className="inline-flex mt-2 xs:mt-0">
              <button
                  onClick={() => {setCurrentPageTest(currentPageTest - 1)}} 
                  className={`${currentPageTest === 1? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium rounded-l`}>
                  Anterior
              </button>
              <button 
                  onClick={() => {setCurrentPageTest(currentPageTest + 1)}}
                  
                  className={`${lastTestIndex >= tests?.length? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium border-0 border-l border-white rounded-r`}>
                  Siguiente
              </button>
          </div>
        </div>
      </div>
      
      <div className={`${isOpenInquiry? "flex": "hidden"} h-screen w-screen fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-50 items-center justify-center px-4 sm:px-10`}> 
        <div className='relative md:max-w-2xl max-w-md w-full flex flex-col justify-center items-center mx-10 sm:mx-5 h-auto bg-white rounded-2xl max-h-popup-mobile py-10'>
          <button onClick={() => {setIsOpenInquiry(!isOpenInquiry)}}
            className='absolute top-1 right-1 hover:text-primary-100 bg-white md:bg-transparent rounded-full'><XMarkIcon className='w-8 h-8 md:w-12 md:h-12'/></button>
          <div className='text-2xl font-medium'>
            Contacto en Línea
          </div>
          
          <div className='w-full h-4/5 py-10 px-10 md:px-20 flex flex-col space-y-6'>
            <input type={"text"} placeholder="Nombre Completo" onChange={(ev) => {setFullName(ev.target.value)}} value={fullName}
              className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
              focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>

            <input type={"text"} placeholder="Correo Electrónico" onChange={(ev) => {setEmail(ev.target.value)}} value={email}
              className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
              focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>

            <input type={"text"} placeholder="Teléfono" onChange={(ev) => {setPhone(ev.target.value)}} value={phone}
              className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
              focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
            
            <textarea className={`md:text-base mt-6 sm:mt-4 py-2 px-4 h-36 w-full text-sm text-input-font bg-primary-300
              focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none`}
              onChange={(ev) => {setMessage(ev.target.value)}} value={message}
              id="description" name="description" rows="7" cols="41" placeholder='Mensaje'></textarea>
          </div>

          <button id="addRegister" onClick={createInquiry}
            className='w-1/2 py-2 text-white font-semibold bg-primary-100 rounded-md text-lg hover:bg-primary-200 cursor-pointer ease-in-out absolute -bottom-5 disabled:bg-primary-200'>
              {!uploading? 
              "Enviar"
              : 
              <div className="w-full flex justify-center items-center"> 
                  <svg fill='none' className="w-8 h-8 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                  <path clipRule='evenodd'
                      d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                      fill='currentColor' fillRule='evenodd' />
                  </svg> 
                  Enviando
              </div>}
          </button>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default ServicesPage;

